import React, { Component } from 'react';
import { string, func } from 'prop-types';
import classnames from 'classnames/bind';

import Illustration from 'foundations/Illustrations/Illustration';
import Button from 'elements/Buttons/Button';
import FormField from 'elements/Inputs/FormField';
import InputField from 'elements/Inputs/InputField';
import Icon from 'foundations/Icons/Icon';
import Form from 'components/Form/Form';
import { Row } from 'components/Form/Layout';

import styles from './SuggestionBoxForm.css';
const cx = classnames.bind(styles);

export default class SuggestionBoxForm extends Component {
  static propTypes = {
    palceholder: string,
    bottomMessage: string,
    successMessage: string,
    greetingMessage: string,
    className: string,
    onSubmit: func,
  }

  static defaultProps = {
    palceholder: 'Help us to know your needs.',
    bottomMessage: 'Share what you believe we could do to improve our service.',
    successMessage: 'Thank you for submitting your opinion.',
    greetingMessag: 'It is very important for us to keep improving your experience',
  }

  state = {
    isFocused: false,
    hasSubmitted: false,
  }

  handleFocus = () => {
    this.setState({
      isFocused: true,
      hasSubmitted: false,
    });
  }

  handleFormSubit = e => {
    e.preventDefault();

    this.setState({
      hasSubmitted: true
    });
  }

  handleNewMessageClick = e => {
    e.preventDefault();

    this.setState({
      isFocused: false,
      hasSubmitted: false
    });
  }

  renderFormFields = () => (
    <div className={cx('formFieldsWrapper')}>
      <p>Let us know you better:</p>
      <Row>
        <FormField darkBg size={'medium-large'}>
          <InputField placeholder="name" name="name" />
        </FormField>
        <FormField darkBg size={'medium-large'}>
          <InputField placeholder="email" name="email" />
        </FormField>
      </Row>
      <Button classes="secondary small white" onClick={this.handleFormSubit}>Submit</Button>
    </div>
  );

  renderSuccessMessage = () => (
    <div className={cx('successMessageView')}>
      <Illustration name={'write'} size={'240'} customClasses={cx('writeIllustration')}/>
      <p className={cx('successMessage', 'main-subtitle')}>
        <span>Thank you for submitting your opinion.</span>
        &nbsp;It is very important for us to keep improving your experience.
      </p>
      <Button classes="secondary small white" onClick={this.handleNewMessageClick}>New Message</Button>
    </div>
  );


  render() {
    const { className, palceholder, bottomMessage, onSubmit } = this.props;
    const { isFocused, hasSubmitted } = this.state;

    const mainWrapperClasses = cx(
      {'onFocus': isFocused, 'hasSubmitted': hasSubmitted },
      'suggestionBoxForm'
    );

    return (
      <Form onSubmit={onSubmit}>
        <div className={classnames(className, mainWrapperClasses)}>
          <div className={cx('formsView')}>
            <div className={cx('topWrapper')}>
              <label className="hotspot-title">Type your message:</label>
              <FormField size={'large'} darkBg>
                <InputField placeholder={palceholder} multiline onFocus={this.handleFocus} />
              </FormField>
            </div>
            <div className={cx('bottomWrapper')}>
              <div className="hint">
                <p className="main-subtitle">{bottomMessage}</p>
                <Icon icon="page-next" type="40"/>
              </div>
              {this.renderFormFields()}
            </div>
          </div>
          {this.renderSuccessMessage()}
        </div>
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/uis/components/Form/SuggestionBoxForm/SuggestionBoxForm.js